// extracted by mini-css-extract-plugin
export default {"popupPage":"popupPage__7s8II","animate":"animate__goT0q","close":"close__ajJvj","header":"header__jc+BD","body":"body__1s6X0"};